export const ADD_TODO = "ADD_TODO";
export const DELETE_TODO = "DELETE_TODO";
export const REMOVE_TODO = "REMOVE_TODO";
export const CHECKED_TODO = "CHECKED_TODO";
export const CHECKEDALL_TODO = "CHECKEDALL_TODO";
